export function parsirajCSV(tekst) {
  const ulaz = tekst.replace(/\r\n?/g, "\n");

  const redci = [];
  let redak = [];
  let polje = "";
  let uNavodnicima = false;

  const zavrsiPolje = () => {
    redak.push(polje.trim());
    polje = "";
  };

  const zavrsiRedak = () => {
    zavrsiPolje();
    redci.push(redak);
    redak = [];
  };

  for (let i = 0; i < ulaz.length; i++) {
    const znak = ulaz[i];

    if (uNavodnicima) {
      if (znak !== '"') {
        polje += znak;
      } else if (ulaz[i + 1] === '"') {
        polje += '"';
        i++;
      } else {
        uNavodnicima = false;
      }
      continue;
    }

    if (znak === '"') {
      uNavodnicima = true;
    } else if (znak === ",") {
      zavrsiPolje();
    } else if (znak === "\n") {
      zavrsiRedak();
    } else {
      polje += znak;
    }
  }

  if (polje !== "" || redak.length > 0) {
    zavrsiRedak();
  }

  return redci.filter((r) => r.some(Boolean));
}
